var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlob(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E78200",
    d: "M39.4,-62.4C53.3,-60.3,68.3,-54.2,68.8,-43.1C69.3,-32,55.3,-16,51.4,-2.2C47.5,11.5,53.7,23.1,52.1,32.1C50.4,41.1,40.8,47.6,30.8,56.1C20.8,64.6,10.4,75.1,2.8,70.3C-4.8,65.5,-9.7,45.3,-15.3,34.3C-20.9,23.2,-27.2,21.3,-35.5,17.1C-43.7,12.9,-53.8,6.5,-58.4,-2.6C-62.9,-11.7,-61.8,-23.4,-57.2,-33.9C-52.6,-44.4,-44.5,-53.8,-34.4,-58C-24.3,-62.3,-12.2,-61.4,0.3,-61.9C12.8,-62.5,25.6,-64.4,39.4,-62.4Z",
    transform: "translate(100 100)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlob);
export default __webpack_public_path__ + "static/media/blob.614ea968984ff44944fafce5baa490f8.svg";
export { ForwardRef as ReactComponent };